import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    DateField,
    EmailField,
    usePermissions,
    useResourceContext,
    EditButton,
    ShowButton,
    Filter,
    SearchInput,
    SelectInput,
    BooleanField
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const StudentFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <SearchInput 
            source='q' 
            alwaysOn 
            placeholder="Search by name, mobile, aadhar" 
        />
        <SelectInput 
            source='gender' 
            choices={[
                { id: 'male', name: 'Male' },
                { id: 'female', name: 'Female' },
                { id: 'other', name: 'Other' },
            ]} 
        />
        <SelectInput 
            source='city' 
            choices={[
                { id: 'Ajmer', name: 'Ajmer' },
                { id: 'Bhilwara', name: 'Bhilwara' },
                { id: 'Beawar', name: 'Beawar' },
                { id: 'Parbatsar', name: 'Parbatsar' },
            ]} 
        />
        <SelectInput 
            source='is_active' 
            choices={[
                { id: '1', name: 'Active' },
                { id: '0', name: 'Inactive' },
            ]} 
        />
    </Filter>
);

export const StudentList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    // Use utility function to process permissions with role-based restrictions
    const propsObj = processPermissions(permissions, resource);
    
    // Enable bulk actions only for admin users (role_id = 1)
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="List of Students" 
                {...props} 
                {...propsObj}
                filters={<StudentFilter />}
                sort={{ field: 'first_name', order: 'ASC' }}
                perPage={25}
            >
                <Datagrid 
                    rowClick={propsObj.hasShow ? 'show' : (propsObj.hasEdit ? 'edit' : false)} 
                    bulkActionButtons={allowBulkActions ? undefined : false}
                >
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <TextField source="first_name" label="First Name" />
                    <TextField source="last_name" label="Last Name" />
                    <DateField source="date_of_birth" label="DOB" />
                    <TextField source="gender" label="Gender" />
                    <TextField source="mobile_number" label="Mobile" />
                    <EmailField source="email" label="Email" />
                    <TextField source="city" label="City" />
                    <TextField source="father_mobile" label="Father Mobile" />
                    <BooleanField source="is_active" label="Active" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
